const da = {
    // Common
    'Close': 'Luk',
    'From': 'Fra',
    'To': 'Til',
    'Distance': 'Distance',
    'Estimated time': 'Forventet tid',
    'Level': 'Etage',
    'Search by name, category, building...': 'Søg efter navn, kategori, bygning...',
    'Show legend': 'Vis forklaring',
    'Ask with AI': 'Spørg med AI',
    'Nothing was found': 'Intet fundet',
    'd': 'd',
    'h': 't',
    'min': 'min',
    'Walk': 'Til fods',
    'Bike': 'Cykling',
    'Transit': 'Offentlig transport',
    'Drive': 'Kørsel',
    'Start wayfinding': 'Start rutebeskrivelse',
    // Location Details
    'Read full description': 'Læs hel beskrivelse',
    // Locations List
    'Locations': 'Lokationer',
    'Directions not available': 'Rutevejledning ikke tilgængelig',
    'Start directions': 'Start rutevejledning',
    // Route instructions
    'Previous': 'Forrige',
    'Next': 'Næste',
    'StepYofX': 'Trin {{activeStep}} ud af {{totalSteps}}',
    // Route Instructions Step
    'You have arrived': 'Du er ankommet',
    'Leave': 'Forlad',
    'Park': 'Parkér',
    'at': 'ved',
    'Building': 'Bygning',
    'Venue': 'Venue',
    'Take staircase to level': 'Tag trappen til etage',
    'Take the ladder to level': 'Tag stigen til etage',
    'Take elevator to level': 'Tag elevatoren til etage',
    'Take escalator to level': 'Tag rulletrappen til etage',
    'Take wheelchair lift to level': 'Tag kørestolsliften til etage',
    'Take wheelchair ramp to level': 'Tag kørestolsrampen til etage',
    'Exit': 'Forlad',
    'Enter': 'Gå ind i',
    'stops': 'stop',
    'and continue': 'og fortsæt',
    'Continue straight ahead': 'Fortsæt ligeud',
    'Go left': 'Drej til venstre',
    'Go sharp left': 'Drej skarpt til venstre',
    'Go slight left': 'Drej en smule til venstre',
    'Go right': 'Drej til højre',
    'Go sharp right': 'Drej skarpt til højre',
    'Go slight right': 'Drej en smule til højre',
    'Turn around': 'Vend om',
    // Wayfinding component
    'Switch': 'Skift',
    'Avoid stairs and escalators': 'Undgå trapper og rulletrapper',
    'Include bus transportation': 'Inkluder bus transport',
    'No route found': 'Ingen rute fundet',
    'My position': 'Min position',
    'Go!': 'Go!',
    'Directions': 'Rutevejledning',
    'Choose departure': 'Vælg startpunkt',
    'Choose destination': 'Vælg destination',
    // Venue selector
    'Venues': 'Venues',
    'Select venue': 'Vælg venue',
    'Current': 'Valgt',
    // QR code dialog
    'Scan QR code': 'Scan QR-kode',
    'Scan the QR code to see the route on your phone': 'Scan QR-koden for at se ruten på din mobil',
    'Done': 'Afslut',
    // Directions
    'Cancel route': 'Annullér ruten',
    'Finish route': 'Afslut ruten',
    // Share location link
    'Share': 'Del',
    'Copy link': 'Kopiér link',
    'QR Code': 'QR-kode',
    //Opening Hours
    'Open': 'Åben',
    'Closed': 'Lukket',
    'Expand opening hours': 'Udvid åbningstider',
    'Collapse opening hours': 'Skjul åbningstider',
    // View Selector
    'Go to view': 'Vis lokation',
    'Close view selector': 'Luk visningsvælger',
    // Language Selector
    'Select language': 'Vælg sprog',
    // Accessibility
    'Increase text size to 200%': 'Forøg tekststørrelse til 200%',
    'Decrease text size to 100%': 'Formindsk tekststørrelse til 100%',
    // Map Controls
    'Zoom in': 'Zoom ind',
    'Zoom out': 'Zoom ud',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - Samtykkeerklæring',
    'Usage consent message': 'Ask with AI hjælper dig med at finde steder og navigere på dette sted ved hjælp af Kunstig Intelligens (AI). Selvom vi stræber efter nøjagtighed, kan AI\'en til tider tage fejl. Dobbelttjek venligst vigtige detaljer, inden du begiver dig af sted.',
    'Usage consent accept': 'Jeg forstår',
    'Usage consent decline': 'Afvis',
    'AI disclaimer': 'Ask with AI kan begå fejl. Dobbelttjek vigtige detaljer, inden du begiver dig af sted.',
    // Location Consent
    'Location consent message': 'For at give personlige rutevejledninger og hjælpe dig med at opdage, hvad der er i nærheden, vil Ask with AI gerne have adgang til din placering. Chatten fungerer stadig uden at kende din placering, men i stedet skal du angive et startpunkt.',
    'Location consent accept': 'Tillad',
    'Location consent decline': 'Afvis',
};

export default da;
